import axios from 'axios';

export function getActiveSubscriptionForAgency(agencyId) {
    return axios.get(`/api/agency/${agencyId}/tariff-plan`);
}

export function getDocumentCountForAgency(agencyId) {
    return axios.get(`/api/agency/${agencyId}/general-document-count`);
}
